"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectTextColorOption')(function selectTextColorOption(color, state) {
    var optionState = state.optionState;
    optionState.fontColor = color;
}));
//# sourceMappingURL=selectTextColorOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-message-format-option/lib/actions/selectTextColorOption.js
// module id = 5155
// module chunks = 2